export default {
  //用户信息
  user: '',
  //用户id
  userId: '',
  //登录状态
  isLogin: false,
  //顶部导航栏菜单激活
  showIndex: '1',
}